/**
 * Order status of Paid, PaymentDue, PaymentOverdue, BilledMonthly or Cancelled.
 */
export enum OrderStatus {
  Paid = 'Paid',
  PaymentDue = 'PaymentDue',
  PaymentOverdue = 'PaymentOverdue',
  BilledMonthly = 'BilledMonthly',
  Cancelled = 'Cancelled',
  AutoPay = 'AutoPay' //Added for fake monthlybilling - transition from monthly invoice to order
}


/**
 * Order type of Prepay, BilledMonthly or FreeCarrierCode.
 */
export enum OrderType {
  Prepay = 'Prepay',
  BilledMonthly = 'BilledMonthly',
  FreeCarrierCode = 'FreeCarrierCode'
}


/**
 * Application type of New, Renew or MonthlyInvoice.
 */
export enum ApplicationType {
  New = 'New',
  Renew = 'Renew',
  MonthlyInvoice = 'MonthlyInvoice'
}

/**
 * Lease status of PendingNew, PendingRenew, Approved or Cancelled.
 */
export enum LeaseStatus {
  PendingNew = 'PendingNew',
  PendingRenew = 'PendingRenew',
  Approved = 'Approved',
  Cancelled = 'Cancelled'
}

/**
 * Lease type of Prepay, BilledMonthly or MonthlyInvoice.
 */
export enum LeaseType {
  Prepay = 'Prepay',
  BilledMonthly = 'BilledMonthly',
  FreeCarrierCode = 'FreeCarrierCode'
}

/**
 * Select type of Random or Select.
 */
export enum SelectType {
  Random = 'Random',
  Selected = 'Selected'
}



/**
 * Reason for the lease status.
 */
export enum StatusReason {
  NoPay = 'NoPay',
  NoRenew = 'NoRenew',
  Rollback = 'Rollback',
  CancelRequested = 'CancelRequested',
  EarlyOptOut = 'MbOptOut',
  Reactivated = 'Reactivated',
  Transferred = 'Transferred',
  Transitional = 'Transitional',
  ReturnToPool = 'ReturnToPool'
}

export enum ShortCodeStatus {
  Available = 'Available',
  Pending = 'Pending',
  Leased = 'Leased',
  Expired = 'Expired',
  Reserved = 'Reserved'
}

/**
 * Status of Monthly Invoice.
 */
export enum MonthlyInvoiceStatus {
  Paid = 'Paid',
  PaymentDue = 'PaymentDue',
  PaymentOverdue = 'PaymentOverdue',
  AutoPay = 'AutoPay'
}

export enum TransferStatus {
  Pending = 'Pending',
  Accepted = 'Accepted',
  Completed = 'Completed',
  Cancelled = 'Cancelled'
}

export enum DialogName {
  ActivateMonthlyBilling = 'ActivateMonthlyBilling',
  AddCreditMemo = 'add-credit-memo',
  AddEditRelatedCompany = 'AddEditRelatedCompany',
  BannerDetail = 'BannerDetail',
  CancelSc = 'cancel-sc',
  Confirm = 'confirm',
  DeactivateMonthlyBilling = 'DeactivateMonthlyBilling',
  UpdateIntendedUsage = 'UpdateIntendedUsage',
  MbOptOut = 'mb-opt-out',
  RegenerateDocument = 'RegenerateDocument',
  ReviewProgramType = 'ReviewProgramType',
  Rollback = 'rollback',
  SetMonthlyBillingPlan = 'SetMonthlyBillingPlan',
  UnapplyPayment = 'UnapplyPayment',
  UpdateCampaignInfo = 'UpdateCampaignInfo',
  UpdateComment = 'UpdateComment',
  UpdateCompanyName = 'UpdateCompanyName',
  UpdateMaxWfp = 'UpdateMaxWfp',


  VetResults = 'VetResults'
}

export enum CampaignType {
  Federal = 'Federal',
  Local = 'Local',
  Other = 'Other',
  State = 'State',
  Tribal = 'Tribal'
}

/**
 * All of the cognito short group names (not ARNs)
 */
export enum ShortCodesRole {
  API = 'API',
  BIReports = 'BIReports',
  Carrier = 'Carrier',
  CarrierAPI = 'CarrierAPI',
  CarrierRegistrant = 'CarrierRegistrant',
  CTIAAdmin = 'CTIAAdmin',
  PublicAPI = 'PublicAPI',
  Registrant = 'Registrant',
  RegistrantAdmin = 'RegistrantAdmin',
  ServiceDesk = 'ServiceDesk',
  ServiceDeskOperations = 'ServiceDeskOperations',
  SuperAdmin = 'SuperAdmin',
  VettingMonitoring = 'VettingMonitoring',
  VettingMonitoringAPI = 'VettingMonitoringAPI'
}

/**
 * Labels that match up with the groups above.
 */
export enum ShortCodesRoleLabels {
  API = 'API',
  BIReports = 'BI Reports',
  Carrier = 'Carrier',
  CarrierAPI = 'Carrier API',
  CarrierRegistrant = 'Carrier Registrant',
  CTIAAdmin = 'CTIA Admin',
  PublicAPI = 'Public API',
  Registrant = 'Registrant',
  RegistrantAdmin = 'Registrant Admin',
  ServiceDesk = 'Service Desk',
  ServiceDeskOperations = 'Service Desk - Operations',
  SuperAdmin = 'Super Admin',
  VettingMonitoring = 'Vetting-Monitoring',
  VettingMonitoringAPI = 'Vetting-Monitoring API'
}

export enum PoliticalCampaignStatus {
  Approved = 'Approved',
  Denied = 'Denied',
  Pending = 'Pending'
}

export enum ProgramType {
  Standard = 'Standard',
  Government = 'Government',
  Charity = 'Charity',
  SMB = 'SMB'
}

export enum ProgramTypeReviewStatus {
  Pending = 'Pending',
  Accepted = 'Accepted',
  Rejected = 'Rejected'
}

export enum VetStatus {
  Inomplete = 'Incomplete',
  Pending = 'Pending',
  Successful = 'Successful'
}

export enum PartnerType {
  Brand = 'Brand',
  ContentProvider = 'ContentProvider'
}

/**
 * Defines the list of flows that a payment or lease edit can be.
 */
export enum OrderTransactionType {
  New = 1, // Regular - no order Id, no codes
  NewPayLater = 2, // NewPaylater means pay for codes (for prepay - new order) with Order Id, has codes - New Application
  Renew = 3, // Renew the existing leased codes , no order Id, has codes
  RenewPayLater = 4, // Pay for the renewed codes (for prepay-renew order) , has order order, has codes but is case of renew (kind of combo of 3 then 2)
  ManualPayMonthlyBilling = 5, // Just the payment for Monthly Bill ( no order Id but has monthly invoice id on the account , for reusability order id=invoice id for the sake of transaction)
  EnrollInMonthlyBilling = 6, // No payment just enrollment of order into monthly.
  Renew1Plus12 = 7, // Pay for 1 but then enroll order into monthly 
  Renew1Plus12PayLater = 8, // Pay for 1 but then enroll order into monthly  but really paylater
  Renew1Plus12AfterDeadline = 9, // Pay for 1 but then enroll order into monthly  but really paylater, but actually TOO LATE
  BulkRenew = 10 // Bulk Renew ( n number of SCs - n is configurable)
}
